export default __webpack_public_path__ + "static/media/log-icon.83d739c5.svg";